"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useProductSearchQuery = useProductSearchQuery;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _shoppingContext = require("@ori/shopping-context");
var _contexts = require("../contexts");
var _logger = require("../logger");
function useProductSearchQuery(hint) {
    const { shoppingContext: { customerId = _auth.NOT_LOGGED_IN_USER_ID } = {} } = (0, _shoppingContext.useShoppingContext)();
    const { periodId } = (0, _contexts.useCheckoutQuickOrderForm)();
    const params = {
        customerId,
        hint,
        periodId
    };
    (0, _logger.logDebug)('useProductSearchQuery() hook called, params:', params);
    const swrOptions = {
        enabled: Boolean(hint),
        onSuccess: ()=>{
            (0, _logger.logDebug)('useProductSearchQuery() hook finished successfully');
        },
        ..._checkoutUtils.errorHandlingSwrOptions
    };
    const { data: { collection: foundProducts = [] } = {}, isValidating: isProductSearchLoading, error: productSearchQueryError } = (0, _globalApiClientReact.useGetApplicationsShoppingBagProducts)(params, undefined, {
        swr: swrOptions
    });
    return {
        foundProducts,
        isProductSearchLoading,
        productSearchQueryError
    };
}
